<script>
import options from './CreatePost.options'
export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-create-post">


    <section class="kb-stafet-flow-title">

      <h1 class="kb-stafet-flow-title__title">{{ getLabel("title", [groupName]) }}</h1>
      <div v-if="groupDescription">
        <div class="kb-stafet-flow-title__breaker">
          <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
          </svg>
        </div>

        <div class="kb-stafet-flow-title__description">
          <p class="kb-stafet-flow-title__description-text">{{ groupDescription }}</p>
        </div>
      </div>
    </section>


    <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

      <div class="kb-stafet-step__input-wrapper">

        <FormInputTextField fieldName="postTitle" v-model="postTitle" :modelValue="postTitle.toString()"
          :label='getLabel("postTitleLabel")' :maxlength="100" :isRequired="true" :isValidationError="postTitle === '' && showInputErrors"
          :errorMessageLabel='getLabel("postTitleErrorMessage")' />

        <div class="kb-create-post__texteditor ValidationRequired"
          :class="postContent === '' && showInputErrors ? 'kb-create-post__texteditor--error' : ''">
          <label class="Form__Element__Caption">{{ getLabel("postContentLabel") }}</label>
          <editor v-if="editorReady" :init='{
            plugins: "emoticons autoresize lists autolink",
            toolbar: "emoticons bold italic underline bullist numlist",
            toolbar_location: "bottom",
            menubar: false,
            statusbar: false
          }' v-model="postContent"></editor>
          <div aria-live="assertive">
            <p v-if="postContent === '' && showInputErrors" role="alert" class="kb-forms Form__Element__ValidationError">
              {{getLabel('postContentErrorMessage') }}
            </p>
          </div>
        </div>

        <AttachmentsEditor
          :files="content?.files ?? []"
          @update:filesToAdd="$event => postFilesToAdd = $event"
          @update:filesToRemove="$event => postFilesToRemove = $event"
        />
        
        <template v-if="isSubmitting">
          <div class="kb-spinner-overlay">
            <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
            </div>
          </div>
        </template>

      </div>
      
      <nav class="kb-stafet-flow-actions">
        <div class="kb-stafet-flow-actions__buttons-right-wrapper">
          <button 
            class="kb-button kb-button--full-color-spot kb-button--full-color-spot" 
            v-on:click="submitCreatePost" 
            :class="{
              'kb-button--disabled': isSubmitting
            }">
            {{ content ? getLabel('editButtonLabel') : getLabel("createButtonLabel") }}
          </button>
        </div>
      </nav>
    </section>
  </article>
</template>